import React from "react";
import { bool, array } from "prop-types";
import { Link } from "react-router";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
  Icon,
} from "@mui/material";

function  TableCompany({loading, companies}) {
    return (
        <>
          {loading ? (
            <>
              <CircularProgress />
              <p>Cargando...</p>
            </>             
          ) :(<Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">No.</TableCell>
                    <TableCell align="left">Nombre</TableCell>
                    <TableCell align="left">No. Reg</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Opción</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    {
                        companies ? companies.map((row, idx) => (
                            <TableRow key={`company-${idx}`}>
                              <TableCell align="left">{idx + 1}</TableCell>
                              <TableCell>{row.name}</TableCell>
                              <TableCell align="left">{row.registerNumber}</TableCell>
                              <TableCell align="left">{row.isActive ? "Activo" : "Inactivo"}</TableCell>
                              <TableCell align="left">
                                <Link to={`/companias/${row._id}`}>
                                  <Icon>edit</Icon>
                                </Link>
                              </TableCell>
                            </TableRow>
                        )) : <p>No existe ningun registro.</p>
                    }
                </TableBody>
              </Table>)}
        </>
    )
}

TableCompany.propTypes = {
    loading: bool,
    companies: array
}

export default TableCompany
